import React from 'react';
import AnimateOnChange from 'react-animate-on-change';

import ExitScreen from '../../containers/ExitScreen';
import LoadingModal from '../../containers/LoadingModal';
import SharingControl from '../sharingControl/SharingControl';
import TrackSelector from '../../containers/TrackSelector';

const style = require('./modalHolder.css');

const showModalContent = (modal, hideElements) => {
  switch (modal.modalType) {
    case 'SharingControl':
      return (
        <div className={style.exitScreen}>
          {hideElements.includes('sharing') ? false : <SharingControl parent="modal" />}
          <ExitScreen />
        </div>
      );
    case 'TrackSelector':
      return <TrackSelector />;
    case 'WaitingForItems':
      return <LoadingModal />;
    default:
      return false;
  }
};

const getModalStyle = modalType => {
  const styles = [style.modal];
  if (modalType === 'TrackSelector') styles.push(style.modalAlignTop);
  if (modalType === 'SharingControl') styles.push(style.exitScreen);
  return styles.join(' ');
};

const Modal = ({ modal, hideElements }) => {
  if (!modal) return null;
  if (modal.modalType === 'SharingControl' && hideElements.includes('exitScreen')) return null;
  return (
    <AnimateOnChange
      baseClassName={getModalStyle(modal.modalType)}
      animationClassName={style.showModal}
      animate={modal !== false}
    >
      <div className={style.holder}>{showModalContent(modal, hideElements)}</div>
    </AnimateOnChange>
  );
};

export default Modal;
